//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SelectCloudfunDialogVue from '../../../../views/workflow/component/select-cloudfun-dialog.vue';
export default {
  name: '',
  components: {
    SelectCloudfunDialogVue,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      visible: false,
      basicInfo: {
        name: '',
        keys: [],
        event_key: '',
        cloud_func_name: '',
        remark: '',
      },
      cloudFunId: '',
      paramsInfo: {
        params: [
          {
            source: '',
            name: '',
            type: '',
          },
        ],
        options: [],
      },
    };
  },
  watch: {},
  created() {},
  beforeMount() {},
  mounted() {},
  methods: {
    openDiaLog() {
      this.visible = true;
      this.basicInfo.keys = [this.info.process_key];
    },
    handleCloseCreateDia() {
      this.beforeClose();
    },
    beforeClose() {
      this.$refs.basicForm.clearValidate();
      this.visible = false;
      this.basicInfo = {
        name: '',
        keys: [],
        cloud_func_name: '',
        remark: '',
      };
      this.cloudFunId = '';
      this.paramsInfo = {
        params: [
          {
            source: '',
            name: '',
            type: '',
          },
        ],
        options: [],
      };
    },
    addParamsItem(index) {
      this.paramsInfo.params.splice(index + 1, 0, {
        source: '',
        name: '',
        type: '',
      });
    },
    deleteParamsItem(index) {
      this.paramsInfo.params.splice(index, 1);
    },
    openCloudTableDiaLog(e) {
      e.preventDefault();
      this.$refs.cloudfunDialog.openDiaLog();
    },
    buttonOpenSelectFunDia() {
      this.$refs.cloudfunDialog.openDiaLog();
    },
    submit() {
      this.$refs.basicForm.validate((valid) => {
        if (!valid) {
          return;
        }
        const detailData = {
          category: 2, // 1是通知事件， 2是云函数
          name: this.basicInfo.name,
          remark: this.basicInfo.remark,
          event_key: this.basicInfo.event_key,
          status: 1,
          template: {
            cloudFunc: {
              name: this.basicInfo.cloud_func_name,
              params: this.paramsInfo.params.map((item) => {
                const paramType =
                  this.paramsInfo.options?.find((opt) => opt.value === item.name)?.type || '';
                return {
                  ...item,
                  type: paramType,
                };
              }),
            },
          },
        };
        this.createEvent(detailData);
      });
    },
    createEvent(data) {
      this.$request({
        url: this.$api.createProcessAction,
        data,
      }).then(async (res) => {
        if (res.id) {
          this.$message.success('创建成功');
          await this.$emit('getEventOptions');
          this.$emit('addEventValue', res.id);
          this.beforeClose();
        }
      });
    },
    setCloudFunName(row) {
      if (row) {
        const { func_name, id, param_in } = row;
        this.basicInfo.cloud_func_name = func_name;
        try {
          if (param_in) {
            const paramsList = JSON.parse(param_in).properties;
            this.paramsInfo.options = Object.keys(paramsList).map((key) => ({
              value: key,
              label: key,
              type: paramsList[key].type,
            }));
          }
        } catch (err) {
          console.error('errr', err);
        }
        if (this.cloudFunId !== id) {
          this.paramsInfo.params = [
            {
              source: '',
              name: '',
              type: '',
            },
          ];
        }
        this.cloudFunId = id;
      }
    },
  },
};
